import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14px",
  height: "14px",
  viewBox: "0 0 14 14",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "ui-x-skinny", -1),
    _createElementVNode("desc", null, "Created with Sketch.", -1),
    _createElementVNode("defs", null, null, -1),
    _createElementVNode("g", {
      id: "Page-1",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", {
        id: "ui-x-skinny",
        fill: "#8595A4"
      }, [
        _createElementVNode("rect", {
          id: "Rectangle",
          transform: "translate(7.000000, 7.000000) rotate(-45.000000) translate(-7.000000, -7.000000) ",
          x: "6",
          y: "-0.778174593",
          width: "2",
          height: "15.5563492"
        }),
        _createElementVNode("rect", {
          id: "Rectangle",
          transform: "translate(7.000000, 7.000000) rotate(-135.000000) translate(-7.000000, -7.000000) ",
          x: "6",
          y: "-0.778174593",
          width: "2",
          height: "15.5563492"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }